import { render, staticRenderFns } from "./new_menu.vue?vue&type=template&id=44afc8dc"
import script from "./new_menu.vue?vue&type=script&lang=js"
export * from "./new_menu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports